export function getPatientName(patient) {
  if (!patient || !patient.person) {
    return 'Not selected'
  }
  return `${patient.person.first_name} ${patient.person.last_name}`
}
